import { Checkbox, CheckboxProps } from '@jisr-hr/ds'
import { Field } from 'react-final-form'

type NewCheckBoxFieldProps = {
  name: string
} & CheckboxProps

const NewCheckBoxField = (props: NewCheckBoxFieldProps): JSX.Element => {
  const { name, ...rest } = props
  return (
    <Field name={name}>
      {({ input }): JSX.Element => (
        <Checkbox
          {...rest}
          active={input.value}
          onChange={(e): void => {
            input.onChange(e)
            props.onChange?.(e)
          }}
        />
      )}
    </Field>
  )
}

export default NewCheckBoxField
